import React from "react";

// Regex that captures http/https URLs (stops at whitespace or common trailing punctuation)
const URL_REGEX = /(https?:\/\/[^\s<>"]+[^\s<>".,;:!?)\]}])/g;

/**
 * Render multiline text and auto-link any http(s) URL to an external <a>.
 * Preserves line breaks via `\n` -> separate paragraphs.
 */
export function renderRichText(text) {
  if (!text) return null;
  const lines = String(text).split("\n");
  return lines.map((line, lineIdx) => {
    if (!line.trim()) return <br key={`br-${lineIdx}`} />;

    const parts = [];
    let lastIndex = 0;
    let match;
    URL_REGEX.lastIndex = 0;

    while ((match = URL_REGEX.exec(line)) !== null) {
      if (match.index > lastIndex) {
        parts.push(line.slice(lastIndex, match.index));
      }
      const url = match[0];
      parts.push(
        <a
          key={`l-${lineIdx}-${match.index}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#C9A961] underline underline-offset-2 hover:text-[#0D2F4C] transition-colors break-all"
        >
          {url}
        </a>
      );
      lastIndex = match.index + url.length;
    }
    if (lastIndex < line.length) parts.push(line.slice(lastIndex));

    return (
      <p key={`p-${lineIdx}`} className="mb-4 last:mb-0">
        {parts.length ? parts : line}
      </p>
    );
  });
}
